import styles from './detailsTooltip.module.css';

const DetailsTooltip = ({countTooltipCss="statusWrapper", data }) => (
  <div
    className={styles.label}
    style={{ fontFamily: "VodafoneRg-Regular" }}
  >
    {Object.entries(data).map(([label, value]) => (
      <div className={styles[countTooltipCss]} key={label}>
        <div className={styles.statusLabel}>{label}</div>
        <div className={styles.separator}>:</div>
        <div className={styles.statusValue}>{value || "---"}</div>
      </div>
    ))}
  </div>
);
export default DetailsTooltip;